import * as React from 'react';
import { Typography } from '@mui/material';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <Typography
        style={{
          paddingLeft: '10px',
          paddingRight: '10px',
          color: '#4f4f4f',
        }}
      >
        &copy; {year} Anthology Inc.
      </Typography>
    </footer>
  );
};

export default Footer;
